import { Box, Checkbox, FormControlLabel, FormGroup, Radio, RadioGroup, Switch } from '@mui/material';
import React, { Component } from 'react';

export class SingleRadio extends Component {
    state = {  }
    render() {
        // const { value, label, onChange } = this.props;
        return (
            <FormControlLabel control={<Radio />} {...this.props} />
            // <FormControlLabel control={<Radio />} label={label} onChange={onChange} value={value} />
        );
    }
}

export class GroupRadio extends Component {
    state = {  }
    render() {
        const { value, arialabel, groupName, onChange, children  } = this.props;
        return (
            <RadioGroup
                aria-label={arialabel}
                style={{ flexDirection: 'row' }}
                name={groupName}
                value={value}
                onChange={onChange}
            >
                {children}
            </RadioGroup>
        );
    }
}
export class SingleSwitch extends Component {
    state = {  }
    render() {
        // const { value, label, onChange } = this.props;
        return (
            <FormControlLabel control={<Switch />} {...this.props} />
            // <FormControlLabel control={<Switch />} label={label} onChange={onChange} value={value} />
        );
    }
}

export class GroupSwitch extends Component {
    state = {  }
    render() {
        const { value, arialabel, groupName, onChange, children  } = this.props;
        return (
            <FormGroup
                aria-label={arialabel}
                style={{ flexDirection: 'column' }}
                name={groupName}
                value={value}
                onChange={onChange}
            >
                {children}
            </FormGroup>
        );
    }
}
export class SingleCheckbox extends Component {
    state = {  }
    render() {
        const { label, onChange, checked, color } = this.props;
        return (
            <FormControlLabel 
                label={label}
                control={
                    <Checkbox 
                        style={{ color: color}}
                        checked={checked} 
                        onChange={(e) => onChange(e)} 
                        color="primary"
                    />
                }
            />
        );
    }
}

export class GroupCheckbox extends Component {
    state = {  }
    render() {
        // const { value, label, arialabel, groupName, onChange, children  } = this.props;
        const { children  } = this.props;
        return (
            <Box sx={{ display: 'flex', flexDirection: 'row', ml: 3 }}>
                {children}
            </Box>
        );
    }
}

                // <Box>
                //     <Checkbox  defaultChecked />
                //     <Checkbox  defaultChecked color="secondary" title={"Projet"} />
                //     <Checkbox  defaultChecked color="success" />
                //     <Checkbox  defaultChecked color="default" />
                //     <Checkbox defaultChecked
                //         sx={{
                //         color: pink[800],
                //         '&.Mui-checked': {
                //             color: pink[600],
                //         },
                //         }}
                //     />
                // </Box>